import React from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { Generic4xx } from '@thd-nucleus/app-render';
import { string, func } from 'prop-types';
import { Error } from './pages';
import { getRoutes } from './routes';
import './styles/app.scss';

export const App = ({ currentRouteName, currentRouteComponent }) => {
  const routes = getRoutes(currentRouteName, currentRouteComponent);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          path={routes.productReviews.path}
          element={<routes.productReviews.component />}
        />
        <Route
          path={routes.questions.path}
          element={<routes.questions.component />}
        />
        <Route
          path={routes.home.path}
          element={<routes.home.component />}
        />
        <Route
          path={routes.thankYou.path}
          element={<routes.thankYou.component />}
        />
        <Route
          path="/error"
          element={<Error />}
        />
        <Route path="/*" element={<Generic4xx />} />
      </Routes>
    </>
  );
};

App.propTypes = {
  currentRouteName: string,
  currentRouteComponent: func
};

App.defaultProps = {
  currentRouteName: null,
  currentRouteComponent: null
};
